<template>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>
    <el-col :xs="24" :sm="24" :md="16" class="ml-20 mr-20">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span class="mr-20">{{ $t('header.profile') }}</span>
        </div>
        <el-form :model="form" :rules="rules" ref="userForm" label-width="80px">
          <el-row>
            <!-- <el-col :span="24" :xs="24" :sm="24" :md="12">
              <el-row>
                <el-col :span="24" :xs="24" :sm="24" :md="24">
                  <UploadWidget fileLimit="profile.form.avatar_limit" :uuid="form.avatar" usage="user_profile" @uploadSuccess="uploadSuccess" />
                </el-col>
              </el-row>
            </el-col> -->

            <el-col :span="24" :xs="24" :sm="24" :md="12">
              <!-- <el-row class="mb-20 text-right">
                <el-col :span="24" :xs="24" :sm="24" :md="24">
                  <el-tooltip class="item" effect="dark" :content="$t('profile.line_integration')" placement="top-start">
                    <el-button type="success" circle @click="connectLine" icon="el-icon-chat-line-round"></el-button>
                  </el-tooltip>
                </el-col>
              </el-row> -->
              <el-row>
                <el-col :span="24" :xs="24" :sm="24" :md="24">
                  <el-form-item :label="$t('profile.form.account')" prop="empno">
                    <el-input v-model="form.empno" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" :xs="24" :sm="24" :md="24">
                  <el-form-item :label="$t('profile.form.username')" prop="username" :label-width="formLabelWidth">
                    <el-input v-model="form.username" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24" :xs="24" :sm="24" :md="24">
                  <el-form-item label="英文名" prop="engName" :label-width="formLabelWidth">
                    <el-input v-model="form.engName" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :xs="24" :sm="24" :md="24" style="text-align: right">
                  <el-button type="danger" @click="saveData('userForm')">{{ $t('buttons.confirm') }}</el-button>
                </el-col>
              </el-row>

            </el-col>

          </el-row>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import UploadWidget from '@/components/upload/'
import {mapGetters} from 'vuex'
import store from "@/store";
import {removeToken} from "@/util";

export default {
  name: "UseProfile",
  components: {
    Breadcrumb,UploadWidget
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error( this.$t('message.required_field') ))
      } else {
        callback()
      }
    }

    return {
      clientId: process.env.VUE_APP_LINE_CLIENT_ID,
      callBack: process.env.VUE_APP_LINE_CALLBACK,
      notifyUrl: process.env.VUE_APP_LINE_NOTIFY,
      formLabelWidth: '',
      form: {
        id: '',
        empno: '',
        username: '',
        avatar: '',
        token:'',
        engName:''
      },
      changeAccount: false,
      rules: {
        username: [{validator: checkName, trigger: 'change'}]
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'token'])
  },
  methods: {
    checkDuplicate(){
      //檢查是否有異動帳號
      if (this.userInfo.empno !== this.form.empno) {
        //檢查是否重覆
        let query = {
          account: this.form.empno
        }
        this.request.get("/user/account/duplicate", {params: query}).then(res => {
          if (res.code === '200') {//帳號不存在，可以更新
            this.changeAccount = true
            this.updateUser()

          } else {
            this.changeAccount = false
            this.$alert(this.form.empno+' 帳號已存在，不可更新', '提醒', {
                    confirmButtonText: 'OK',
                    callback: action => {
                      this.form.empno = this.userInfo.empno
                    }
                  });
          }
        })

      } else {
        this.changeAccount = false
        this.updateUser()
      }
    },
    loadData() {
      this.form.id = this.userInfo.id
      this.form.avatar = this.userInfo.avatar
      this.form.empno = this.userInfo.empno
      this.form.username = this.userInfo.username
      this.form.engName = this.userInfo.engName
      this.form.token = this.userInfo.token
    },
    updateUser(){
      this.request.post("/user/account/update", this.form).then(async res => {
        if (res.code === '200') {

          if (this.changeAccount) {
            console.log('帳號有更換')
            //如果帳號換了，token使用就會出問題，因為已經是不正確的token了
            //所以更新成功後，要強制登出，刪除token
            let msg = '因帳號已更換，將會被立即登出'
            let title = this.$t('message.alert')
            this.$alert(msg, title, {
              confirmButtonText: 'OK',
              callback: action => {
                //清除token
                removeToken('ER_ADMIN_TOKEN')
                this.$router.push('/')
              }
            });
          } else {
            console.log('帳號沒有更換')
            await this.$store.dispatch('login/getUserInfo', this.form.token)
            this.showResult('success', this.$t('action.save_success'))
          }
          

        } else {
          this.showResult('error', this.$t('action.save_error', {err: e}))
        }
      })
    },
    saveData(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.checkDuplicate()
        }
      })
    },
    uploadSuccess(res){
      this.form.avatar = res.uuid
    },
    connectLine(){
      //console.log(`${this.notifyUrl}&client_id=${this.clientId}&redirect_uri=${this.callBack}&state=${this.userInfo.id}`)
      window.open(`${this.notifyUrl}&client_id=${this.clientId}&redirect_uri=${this.callBack}&state=${this.userInfo.id}`,"_new")
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}


</style>
